module.exports = "fragment FilterFragment on Filter {\n  name\n  urlEncodedValues\n}\n"